import { TAssetProfile } from '@interfaces/assets/asset';
import { IAssetFormValues } from '@interfaces/components/form';

import { ECoordFormat } from '@enums/common';
import { EAssetSiteA11yStatus, EBackhaulA11yStatus, EPowerSupplyA11yStatus } from '@enums/map';

export const prepareDefaultValues = ({
	assetData,
	isEditMode,
}: {
	assetData?: TAssetProfile;
	isEditMode: boolean;
}): IAssetFormValues => {
	return ({
		adLocality: assetData?.adLocality || '',
		adPostCode: assetData?.adPostCode || '',
		adPropertyNoName: assetData?.adPropertyNoName || '',
		adStreetName: assetData?.adStreetName || '',
		adTownCity: assetData?.adTownCity || '',
		assetAccessDetails: assetData?.assetAccessDetails || '',
		assetAccessDetailsFileIds: assetData?.assetAccessDetailsFileIds || [],
		assetId: assetData?.assetId || '',
		assetOwnerNotes: assetData?.assetOwnerNotes || '',
		assetSiteAvailabilityDetails: assetData?.assetSiteAvailabilityDetails || '',
		assetSiteAvailabilityDetailsFileIds: assetData?.assetSiteAvailabilityDetailsFileIds || [],
		assetSiteAvailabilityStatus: assetData?.assetSiteAvailabilityStatus?.name || EAssetSiteA11yStatus.green,
		subType: null,
		assetType: null,
		backhaulAccessibilityDetails: assetData?.backhaulAccessibilityDetails || '',
		backhaulAccessibilityDetailsFileIds: assetData?.backhaulAccessibilityDetailsFileIds || [],
		backhaulAccessibilityStatus: assetData?.backhaulAccessibilityStatus?.name || EBackhaulA11yStatus.green,
		contactPersonId: null,
		coordFormat: assetData?.easting ? ECoordFormat.utm : ECoordFormat.latlon,
		height: assetData?.height?.toString() || '',
		indicativeAcceptablePricing: assetData?.indicativeAcceptablePricing?.toString() || '',
		isAvailable: isEditMode ? assetData?.isAvailable : true,
		lastVerificationDate: assetData?.lastVerificationDate || null,
		lat: assetData?.easting?.toString() || assetData?.lat?.toString() || '',
		lng: assetData?.northing?.toString() || assetData?.lng?.toString() || '',
		locationDescription: assetData?.locationDescription || '',
		maxOperators: assetData?.maxOperators?.toString() || '1',
		ngr: assetData?.ngr || '',
		powerSupplyAvailabilityDetails: assetData?.powerSupplyAvailabilityDetails || '',
		powerSupplyAvailabilityDetailsFileIds: assetData?.powerSupplyAvailabilityDetailsFileIds || [],
		powerSupplyAvailabilityStatus: assetData?.powerSupplyAvailabilityStatus?.name || EPowerSupplyA11yStatus.green,
		responsible: null,
		siteAvailabilityReviewDate: assetData?.siteAvailabilityReviewDate || null,
		specialImplementationIssueDetails: assetData?.specialImplementationIssueDetails || '',
		specialImplementationIssueDetailsFileIds: assetData?.specialImplementationIssueDetailsFileIds || [],
		specialImplementationIssuesExist: isEditMode ? assetData?.specialImplementationIssuesExist : true,
		uprn: assetData?.uprn || '',
	});
};
